const KEY = 'munibus.recorridoId';

export function getStoredRecorridoId() {
  try {
    return window.localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

/** @param {string} recorridoId */
export function setStoredRecorridoId(recorridoId) {
  try {
    if (recorridoId) window.localStorage.setItem(KEY, recorridoId);
  } catch {
    /* ignore */
  }
}
